var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AuthHeading',{attrs:{"title":_vm.title,"sub-title":"Enter your Email below and we get you back on track."}}),_c('AuthForm',{attrs:{"is-reset-password-send-email":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }